import { Box, IconButton, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import './SupportResolveModal.css';
import closeIcon from '../../../../../assets/Admin/RequestImages/close-icon.svg';
import approveIcon from '../../../../../assets/Admin/RequestImages/approve-icon.svg';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '30% !important',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const SupportResolveModal = ({ setResolveOpen, onResolve }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setResolveOpen(false);
  };

  const handleResolve = async () => {
    setIsLoading(true);
    try {
      await onResolve();
      handleClose();
    } catch (error) {
      console.error('Error in resolve modal:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={true}
      aria-labelledby="support-resolve-modal-title"
      aria-describedby="support-resolve-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-[5%] py-4 border-b border-[#D5DEE3]">
          <Typography className="support-resolve-title">Resolve Support Ticket</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center gap-4 px-6 py-4 border-b border-[#D5DEE3]">
          <img src={approveIcon} alt="resolve" width="132.727px" height="70px" />
          <Typography className="support-resolve-text">
            You're about to mark this support ticket as resolved. Do you want to continue?
          </Typography>
        </Box>
        <Box className="flex items-center justify-center gap-4 px-6 py-4">
          <button className="support-cancel-button" onClick={handleClose} disabled={isLoading}>
            Cancel
          </button>
          <button className="support-confirm-button" onClick={handleResolve} disabled={isLoading}>
            {isLoading ? 'Processing...' : 'Confirm'}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SupportResolveModal;
